var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { Checkbox, FormControlLabel, FormHelperText, Switch } from '@mui/material';
import { createReactTooltip } from '../../common/tooltip';
import { getVersionBrowserColoringClass } from '../../versionBrowser/utils';
var SwitchField = function (_a) {
    var name = _a.name, value = _a.value, tooltip = _a.tooltip, disabled = _a.disabled, errorMessage = _a.errorMessage, onChange = _a.onChange, label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'end' : _b, inverted = _a.inverted, displayAsCheckbox = _a.displayAsCheckbox, coloring = _a.coloring;
    var _c = createReactTooltip(tooltip, 'switchField-' + name), tooltipAnchorParams = _c.tooltipAnchorParams, tooltipElement = _c.tooltipElement;
    var BooleanComponent = displayAsCheckbox ? Checkbox : Switch;
    return (React.createElement("div", __assign({ className: classNames('switchFieldWrapper', getVersionBrowserColoringClass(coloring)), "data-testid": "switchField-" + name }, tooltipAnchorParams),
        React.createElement(FormControlLabel, { control: React.createElement(BooleanComponent, { checked: value, disabled: disabled, onChange: onChange, color: "primary" }), label: label, labelPlacement: labelPosition, className: classNames('switchField', {
                'switchField--inverted': inverted,
                'switchField--error': errorMessage
            }), "html-input-name": 'switch-field' }),
        (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.trim()) && React.createElement(FormHelperText, { className: 'switchField__errorMessage' }, errorMessage),
        tooltipElement));
};
export default SwitchField;
//# sourceMappingURL=SwitchField.js.map